module.exports = "/_next/static/media/06fb13c400208c1deb16b48a0f8845b7.svg";